(function () {
  "use strict";

  // =====================================================
  // NAV — solid bg on scroll + mobile menu
  // =====================================================
  const nav = document.getElementById('nav');
  if (nav) {
    const sticky = nav.dataset.sticky !== 'false';
    const onScroll = () => {
      if (sticky && window.scrollY > 60) nav.classList.add('scrolled');
      else nav.classList.remove('scrolled');
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    const toggle = document.getElementById('navToggle');
    if (toggle) {
      toggle.addEventListener('click', () => {
        const open = nav.classList.toggle('menu-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      nav.querySelectorAll('.nav-links a').forEach(a => {
        a.addEventListener('click', () => {
          nav.classList.remove('menu-open');
          toggle.setAttribute('aria-expanded', 'false');
        });
      });
    }
  }

  // =====================================================
  // CAROUSEL
  // =====================================================
  // Native horizontal scroller: touch-swipe works on mobile, arrows
  // smooth-scroll one card at a time on desktop.
  const carousel = document.getElementById('carousel');
  const prevBtn = document.getElementById('prevBtn');
  const nextBtn = document.getElementById('nextBtn');
  if (carousel && prevBtn && nextBtn) {
    const wrap = carousel.parentElement;
    const getStep = () => {
      const card = carousel.querySelector('.product-card');
      if (!card) return 0;
      const gap = parseFloat(getComputedStyle(carousel).gap) || 24;
      return card.getBoundingClientRect().width + gap;
    };
    prevBtn.addEventListener('click', () => { wrap.scrollBy({ left: -getStep(), behavior: 'smooth' }); });
    nextBtn.addEventListener('click', () => { wrap.scrollBy({ left: getStep(), behavior: 'smooth' }); });
  }

  // =====================================================
  // QUIZ
  // =====================================================
  const quiz = document.getElementById('quiz');
  if (quiz) {
    const answers = { method: null, flavor: null, type: null, strength: null };
    let step = 1;
    const totalSteps = 4;
    const dots = quiz.querySelectorAll('.quiz-dot');
    const steps = quiz.querySelectorAll('.quiz-step');
    const backBtn = document.getElementById('quizBack');
    const nextBtnQ = document.getElementById('quizNext');
    const quizNav = document.getElementById('quizNav');
    const stepKeys = ['method', 'flavor', 'type', 'strength'];

    function showStep(n) {
      steps.forEach(s => s.classList.remove('active'));
      if (n === 'result') {
        quiz.querySelector('.quiz-step[data-step="result"]').classList.add('active');
        if (quizNav) quizNav.style.display = 'none';
        dots.forEach(d => d.classList.add('done'));
      } else {
        quiz.querySelector('.quiz-step[data-step="' + n + '"]').classList.add('active');
        if (quizNav) quizNav.style.display = 'flex';
        dots.forEach((d, i) => {
          d.classList.remove('active', 'done');
          if (i + 1 < n) d.classList.add('done');
          if (i + 1 === n) d.classList.add('active');
        });
        if (backBtn) backBtn.disabled = n === 1;
        const key = stepKeys[n - 1];
        if (nextBtnQ) {
          nextBtnQ.disabled = !answers[key];
          nextBtnQ.textContent = n === totalSteps ? 'See My Match' : 'Continue';
        }
      }
    }

    steps.forEach(s => {
      s.querySelectorAll('.quiz-opt').forEach(opt => {
        opt.addEventListener('click', () => {
          const stepNum = s.dataset.step;
          if (stepNum === 'result') return;
          const key = stepKeys[parseInt(stepNum, 10) - 1];
          s.querySelectorAll('.quiz-opt').forEach(o => o.classList.remove('selected'));
          opt.classList.add('selected');
          answers[key] = opt.dataset.val;
          if (nextBtnQ) nextBtnQ.disabled = false;
        });
      });
    });

    if (backBtn) backBtn.addEventListener('click', () => { if (step > 1) { step--; showStep(step); } });
    if (nextBtnQ) nextBtnQ.addEventListener('click', () => {
      if (step < totalSteps) { step++; showStep(step); }
      else { computeResult(); showStep('result'); }
    });

    // Fallback coffee roster — used only when the section provides no
    // data-quiz-roster JSON island (no quiz collection set, or no products
    // with quiz metafields). Live data comes from find-roast.liquid.
    // method = hard filter (only these brew with that answer);
    // flavour/type/strength = soft scoring. 'balanced' applies to every coffee.
    const defaultRoster = [
      { name: 'Triple Threat',                          origin: 'South America & Southeast Asia · Natural & Washed · Light-Medium', notes: ['Fruity', 'Floral', 'Chocolatey'],                              desc: 'Two-origin espresso blend — fruit and florals up front, chocolate underneath. Big crema, easy to love.', method: ['espresso'], flavour: ['balanced', 'bold'],   type: 'blend',  strength: 'strong', url: '/products/triple-threat' },
      { name: 'Brazil - Minas Gerais',                  origin: 'Brazil · Natural · Light-Medium',                     notes: ['Vanilla', 'Hazelnut', 'Milk Chocolate'],                       desc: 'Sweet, nutty and chocolatey — the comfort espresso that plays perfectly with milk.',                     method: ['espresso'], flavour: ['balanced', 'bold'],   type: 'single', strength: 'strong', url: '/products/brazil-minas-gerais' },
      { name: 'Ethiopia - Guji Oromia Shakiso',       origin: 'Ethiopia · Natural · Light-Medium',                   notes: ['Blueberry', 'Orange', 'Earl Grey'],                            desc: 'Berry-bright natural from Guji — blueberry sweetness with a tea-like finish.',                           method: ['espresso'], flavour: ['balanced', 'fruity'], type: 'single', strength: 'light',  url: '/products/ethiopia-shakiso' },
      { name: 'Ethiopia - Guji Rogicha',                origin: 'Ethiopia · Natural · Light-Medium',                   notes: ['Apple Cider', 'Milk Chocolate', 'Blackberry', 'Peach'],        desc: 'Fruit-forward and syrupy — apple-cider sweetness over soft chocolate.',                                  method: ['espresso'], flavour: ['balanced', 'fruity'], type: 'single', strength: 'medium', url: '/products/ethiopia-rogicha' },
      { name: 'Colombia - Velvet Bliss Huila',          origin: 'Colombia · Anaerobic Washed · Light',                 notes: ['Peach', 'Red Apple', 'Floral', 'Milk Chocolate'],              desc: 'Juicy stone fruit and florals that finish on milk chocolate. A silky pour-over.',                        method: ['pourover'], flavour: ['balanced', 'fruity'], type: 'single', strength: 'light',  url: '/products/colombia-velvet-bliss-huila' },
      { name: 'Kenya - Nandi AA',                        origin: 'Kenya · Washed · Light',                              notes: ['Tropical Fruit', 'Cacao Nibs', 'Black Cherry', 'Lime'],        desc: 'Punchy and complex — tropical fruit and black cherry over cacao nibs.',                                  method: ['pourover'], flavour: ['balanced', 'bold'],   type: 'single', strength: 'strong', url: '/products/kenya-nandi-aa' },
      { name: 'El Salvador - Finca Himalaya Micro-Lot', origin: 'El Salvador · Natural · Light',                       notes: ['Apricot', 'Passion Fruit', 'Mandarin Orange', 'Dark Chocolate'], desc: 'A layered Pacamara micro-lot — stone fruit and brown spices on a dark chocolate base.',                method: ['pourover'], flavour: ['balanced'],          type: 'single', strength: 'medium', url: '/products/el-salvador-finca-himalaya' },
      { name: 'Ethiopia - Yirgacheffe Haru Suke',       origin: 'Ethiopia · Anaerobic Natural · Light',                notes: ['Honey', 'Jasmine', 'Sweet Nectar', 'Peach'],                   desc: 'Delicate anaerobic natural from Yirgacheffe — honeyed, floral and nectar-sweet.',                        method: ['pourover'], flavour: ['balanced', 'fruity'], type: 'single', strength: 'light',  url: '/products/ethiopia-haru-suke' }
    ];

    let roster = defaultRoster;
    const rosterEl = quiz.querySelector('script[data-quiz-roster]');
    if (rosterEl) {
      try {
        const injected = JSON.parse(rosterEl.textContent);
        if (Array.isArray(injected)) {
          const valid = injected.filter(c =>
            c && c.name && Array.isArray(c.method) && c.method.length &&
            Array.isArray(c.flavour) && c.type && c.strength);
          if (valid.length) {
            valid.forEach(c => { c.notes = (c.notes || []).map(n => String(n).trim()).filter(Boolean); });
            roster = valid;
          }
        }
      } catch (e) { /* malformed island — keep defaultRoster */ }
    }

    function esc(s) {
      return String(s == null ? '' : s)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;')
        .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }

    function computeResult() {
      const m = answers.method;
      let pool = roster.filter(c => !m || c.method.indexOf(m) !== -1);
      if (!pool.length) pool = roster.slice();
      pool.forEach(c => {
        let s = 0;
        if (answers.flavor && c.flavour.indexOf(answers.flavor) !== -1) s++;
        if (answers.type && c.type === answers.type) s++;
        if (answers.strength && c.strength === answers.strength) s++;
        c._score = s;
      });
      const max = pool.reduce((a, c) => Math.max(a, c._score), 0);
      const matches = pool.filter(c => c._score === max).slice(0, 3);
      const box = document.getElementById('rMatches');
      if (!box) return;
      box.innerHTML = matches.map(c => {
        const notes = c.notes.map(n => '<span class="result-note">' + esc(n) + '</span>').join('');
        return '<div class="result-match">' +
          '<h3 class="result-name">' + esc(c.name) + '</h3>' +
          '<div class="result-origin">' + esc(c.origin) + '</div>' +
          '<div class="result-notes">' + notes + '</div>' +
          '<p class="result-desc">' + esc(c.desc) + '</p>' +
          '<a class="result-shop" href="' + esc(c.url) + '">Shop this coffee &rarr;</a>' +
          '</div>';
      }).join('');
    }

    const restart = document.getElementById('restartQuiz');
    if (restart) restart.addEventListener('click', () => {
      step = 1;
      Object.keys(answers).forEach(k => answers[k] = null);
      quiz.querySelectorAll('.quiz-opt.selected').forEach(o => o.classList.remove('selected'));
      showStep(1);
    });
  }

  // =====================================================
  // REVEAL ON SCROLL
  // =====================================================
  const revealEls = document.querySelectorAll('.coffee-card, .product-card, .sub-card, .station, .promise-headline, .upcoming-title, .products-title, .find-title, .subs-title');
  if ('IntersectionObserver' in window && revealEls.length) {
    const reveal = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.style.opacity = '1';
          e.target.style.transform = 'translateY(0)';
          reveal.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    revealEls.forEach(el => {
      el.style.opacity = '0';
      el.style.transform = 'translateY(28px)';
      el.style.transition = 'opacity .8s ease, transform .8s cubic-bezier(.2,.7,.2,1)';
      reveal.observe(el);
    });

    setTimeout(() => {
      document.querySelectorAll('[style*="opacity: 0"]').forEach(el => {
        if (el.style.transform && el.style.transform.includes('translateY')) {
          el.style.opacity = '1';
          el.style.transform = 'translateY(0)';
        }
      });
    }, 3500);
  }
})();
